// src/pages/BlogDetails.jsx
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import SEO from '../components/SEO';
import blogData from '../data/blogData';
import '../styles/BlogDetails.css';

const BlogDetails = () => {
  const { id } = useParams();
  const blog = blogData.find((item) => item.id === parseInt(id, 10));

  if (!blog) {
    return (
      <div className="blog-details">
        <SEO title="Blog Not Found | Bularis Tech" description="The requested blog post could not be found." path={`/blog/${id}`} noIndex />
        <h1>Blog Not Found</h1>
        <Link to="/blog">← Back to Blog</Link>
      </div>
    );
  }

  return (
    <div className="blog-details">
      <SEO title={`${blog.title} | Bularis Tech`} description={blog.description} path={`/blog/${id}`} noIndex />
      <h1>{blog.title}</h1>
      <div
        className="prose prose-lg"
        dangerouslySetInnerHTML={{ __html: blog.content }}
      />
      <Link className="back-link" to="/blog">← Back to Blog</Link>
    </div>
  );
};

export default BlogDetails;
